import React, { ChangeEvent, ReactNode, forwardRef } from "react";
import styled from "styled-components/macro";

const StyledRoot = styled.div`
  display: flex;
  gap: 0.5em;
  font-size: var(--font-size-small);
  &:hover {
    color: var(--primary-black);
  }
  .field-error {
    color: var(--error-color);
    font-family: var(--inter-font);
  }
`;

export const StyledRadio = styled.div<{
  selected: boolean;
  disabled?: boolean;
}>`
  width: 1rem;
  height: 1rem;
  position: relative;
  flex-shrink: 0;

  &::before {
    display: block;
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    transform: translateX(20%) translateY(20%);
    background: ${({ selected, disabled }) =>
      selected
        ? disabled
          ? "var(--placeholder-color)"
          : "var(--green)"
        : null};
    width: 75%;
    height: 75%;
    border-radius: 50%;
  }

  &::after {
    display: block;
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid
      ${({ disabled }) =>
        disabled ? "var(--placeholder-color)" : "var(--green)"};
    border-radius: 50%;
    width: calc(100% - 1px);
    height: calc(100% - 1px);
  }
`;

const Input = styled.input`
  display: none;
  top: 0;
  left: 0;
`;

interface RadioProps {
  label: string | ReactNode;
  name: string;
  className?: string;
  error?: string;
  isRequired?: boolean;
  onChange?: (value: string) => void;
  checked?: boolean;
  value?: string;
  disabled?: boolean;
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>((props, ref) => {
  return (
    <StyledRoot className={props.className}>
      <label className="row">
        <StyledRadio selected={!!props.checked} disabled={props.disabled} />
        <Input
          type="radio"
          disabled={props.disabled}
          ref={ref}
          name={props.name}
          className={`${props.error ? "field-error" : ""}`}
          value={props.value}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            props.onChange ? props.onChange(event.target.value) : undefined;
          }}
          checked={props.checked}
        />
        {props.label}
      </label>
      {props.isRequired && <span className="error">*</span>}
    </StyledRoot>
  );
});

Radio.displayName = "Radio";
